<template>
  <common-template>
    <div v-show="!load">
        <div class="list">
          <h1 id="board-title" class="title d-flex border-bottom inner">
            {{ $t(pageTitle) }}
          </h1>
          <div
            id="board-select"
            class="inner d-flex justify-content-end mt-4 mb-2"
          >
            <div class=" d-flex justify-content-start w-50">
              <button
                type="button"
                class="btn btn-light mr-2"
                @click="companyModalOpen()"
              >
                {{ $t('会社情報登録') }}
              </button>
              <button
                type="button"
                class="btn btn-success mr-2"
                @click="factoryModalOpen()"
              >
                {{ $t('工場登録') }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="departmentModalOpen()"
              >
                {{ $t('部署登録') }}
              </button>
            </div>
            <div
              class="form-group d-flex justify-content-end align-items-center mb-0 w-50"
            >
              <select v-model="siteId" class="form-control mr-2 w-25">
                <option value="">-</option>
                <option
                  v-for="item in factories"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</option
                >
              </select>
              <select v-model="depId" class="form-control w-25">
                <option value="">-</option>
                <option
                  v-for="item in changeDepartment"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</option
                >
              </select>
            </div>
          </div>
          <div class="board inner">
            <div id="board-head-wrap">
              <div
                class="d-flex border-left border overflow-hidden"
                id="board-head"
              >
                <div class="w-35 border-right board-head-left">
                  <div class="d-flex align-items-end h-100">
                    <button
                      type="button"
                      class="btn btn-success ml-3 mb-3"
                      @click="facilityModalOpen()"
                    >
                      {{ $t('工程登録') }}
                    </button>
                  </div>
                </div>
                <div class="w-65 board-head-right">
                  <table class="table m-0">
                    <thead class="thead">
                      <tr>
                        <th
                          v-for="(item, index) in monthlySchedule"
                          :key="`mouth-${index}`"
                          :style="`width: ${item.days.length * 60}px;`"
                          :colspan="item.days.length"
                          class="text-left border-top-0 border-bottom-0 border-right"
                        >
                          {{ item.month }}
                        </th>
                      </tr>
                      <tr>
                        <template v-for="(item, index) in monthlySchedule">
                          <template v-for="(day, num) in item.days">
                            <td
                              :key="`day-${index}-${num}`"
                              :class="{
                                'wf-60': true,
                                'border-right': true,
                                'board-calendar-holiday': day.isHoliday,
                              }"
                            >
                              {{ day.format }}
                            </td>
                          </template>
                        </template>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
            <div
              class="d-flex border-left border border-top-0 overflow-auto"
              id="board-body"
            >
              <div class="w-35">
                <table id="board-body-left-table" class="table mb-0">
                  <tbody class="tbody overflow-auto">
                    <template v-for="(item, index) in changeProcesses">
                      <tr
                        :key="`process-${index}`"
                        :class="{
                          'white-space-nowrap': true,
                          'overflow-hidden': true,
                          'board-body-even': mixinEvenOrOdd(index),
                          'board-body-odd': !mixinEvenOrOdd(index),
                        }"
                      >
                        <td
                          class="text-left border-right border-top-0 border-bottom align-top w-30 hf-38 overflow-hidden"
                          :rowspan="
                            item.userIds.length === 0 ? 1 : item.userIds.length
                          "
                        >
                          {{ getProcessKindMessageKey(item) }}
                        </td>
                        <td
                          class="text-left border-right border-top-0 border-bottom align-top w-40 hf-38"
                          :rowspan="
                            item.userIds.length === 0 ? 1 : item.userIds.length
                          "
                        >
                          <div class="d-flex overflow-hidden">
                            <div
                              class="text-nowrap m-0 overflow-hidden flex-fill"
                            >
                              {{ item.name }}
                            </div>
                            <div
                              class="overflow-hidden flex-grow-0 flex-shrink-0"
                            >
                              <button
                                class="btn btn-light btn-board mr-1"
                                @click="facilityModalOpen(item)"
                              >
                                <font-awesome-icon :icon="['far', 'edit']" />
                              </button>
                              <button
                                class="btn btn-light btn-board mr-1"
                                :class="{
                                  invisible: index === 0,
                                }"
                                @click="updateProcessSortUp(index)"
                              >
                                <font-awesome-icon
                                  :icon="['fas', 'arrow-up']"
                                />
                              </button>
                              <button
                                class="btn btn-light btn-board"
                                :class="{
                                  invisible:
                                    changeProcesses.length === index + 1,
                                }"
                                @click="updateProcessSortDown(index)"
                              >
                                <font-awesome-icon
                                  :icon="['fas', 'arrow-down']"
                                />
                              </button>
                            </div>
                          </div>
                        </td>
                        <td
                          v-if="item.userIds.length"
                          class="text-left border-top-0 border-bottom border-right hf-38"
                        >
                          <div
                            class="text-nowrap float-left w-65 overflow-hidden"
                          >
                            {{
                              mixinIdKeyDisplay(
                                'users',
                                item.userIds[0],
                                'name',
                              )
                            }}
                          </div>
                          <div class="w-35 float-right overflow-hidden">
                            <button
                              @click="
                                userModalOpen(
                                  mixinIdObjectDisplay(
                                    'users',
                                    item.userIds[0],
                                  ),
                                )
                              "
                              class="btn btn-light btn-board"
                            >
                              <font-awesome-icon :icon="['far', 'edit']" />
                            </button>
                          </div>
                        </td>
                        <td
                          v-else
                          class="border-top-0 border-bottom border-right"
                        ></td>
                      </tr>
                      <template v-if="item.userIds.length > 1">
                        <template v-for="(user, num) in item.userIds">
                          <tr
                            v-if="num !== 0"
                            :key="`user-${index}-${num}`"
                            :class="{
                              'overflow-hidden': true,
                              'board-body-even': mixinEvenOrOdd(index),
                              'board-body-odd': !mixinEvenOrOdd(index),
                            }"
                          >
                            <td
                              class="text-left border-top-0 border-bottom border-right hf-38"
                            >
                              <div
                                class="text-nowrap float-left w-65 overflow-hidden"
                              >
                                {{ mixinIdKeyDisplay('users', user, 'name') }}
                              </div>
                              <div class="w-35 float-right overflow-hidden">
                                <button
                                  @click="
                                    userModalOpen(
                                      mixinIdObjectDisplay('users', user),
                                    )
                                  "
                                  class="btn btn-light btn-board"
                                >
                                  <font-awesome-icon :icon="['far', 'edit']" />
                                </button>
                              </div>
                            </td>
                          </tr>
                        </template>
                      </template>
                      <tr
                        :key="`btn-${index}`"
                        :class="{
                          'overflow-hidden': true,
                          'board-body-even': mixinEvenOrOdd(index),
                          'board-body-odd': !mixinEvenOrOdd(index),
                        }"
                      >
                        <td
                          class="text-left border-right border-top-0 border-bottom overflow-hidden hf-38"
                        ></td>
                        <td
                          class="text-left border-right border-top-0 border-bottom overflow-hidden hf-38"
                        ></td>
                        <td
                          class="text-right border-top-0 border-bottom border-right overflow-hidden hf-38"
                        >
                          <button
                            type="button"
                            class="text-nowrap btn btn-light btn-board overflow-hidden"
                            @click="assignedModalOpen(item)"
                          >
                            {{ $t('担当者選択') }}
                          </button>
                          <button
                            type="button"
                            class="text-nowrap btn btn-success btn-board overflow-hidden"
                            style="margin-left:4px"
                            @click="userModalOpen({}, item.id)"
                          >
                            {{ $t('担当者登録') }}
                          </button>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div class="w-65 board-body-right align-items-stretch">
                <div
                  class="board-body-right__inner"
                  id="board-body-right__inner"
                ></div>
              </div>
            </div>
          </div>
      </div>
      <div class="footer-bg" id="board-footer"></div>
      <company-modal
        ref="company"
        :company="master.company"
        @registed="init()"
      ></company-modal>
      <factory-modal
        ref="factory"
        @registed="init()"
      ></factory-modal>
      <department-modal
        ref="department"
        :propsFactories="factories"
        @registed="init()"
      ></department-modal>
      <facility-modal
        ref="facility"
        @registed="init()"
      ></facility-modal>
      <assigned-modal
        ref="assigned"
        @registed="init()"
      ></assigned-modal>
      <user-modal
        ref="user"
        @registed="init()"
      ></user-modal>
    </div>
    <template v-if="load">
      <div class="d-flex justify-content-center input-loading">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </template>
  </common-template>
</template>

<script>
import { mapGetters } from 'vuex'
import departmentModal from '../department/createModal.vue'
import assignedModal from '../facility/assignedModal.vue'
import facilityModal from '../facility/createModal.vue'
import factoryModal from '../factory/createModal.vue'
import userModal from '../user/createModal.vue'
import companyModal from './companyModal.vue'

export default {
  data() {
    return {
      list: [],
      master: {},
      processes: [],
      processKinds: [],
      users: [],
      factories: [],
      departments: [],
      load: false,
      depId: null,
      siteId: null,
      pageTitle: '工程ボード',
    }
  },
  components: {
    companyModal,
    factoryModal,
    departmentModal,
    facilityModal,
    assignedModal,
    userModal,
  },
  async created() {
    // 操作ブロックのためローディングを表示する
    this.load = true
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(this.$t('データ取得エラーメッセージ'))
    }
    await this.init()
    // ローディング表示を終了させる
    this.load = false
  },
  mounted() {
    this.adjustmentHeight()
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  methods: {
    // masterを取得
    async getMasterData() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/masters`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          },
        )
        this.master = res.data
        this.users = this.master.users
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 工程を取得
    async getProcessData() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/processes`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: {
              limit: 600,
            },
          },
        )
        this.processes = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 工程区分を取得
    async getProcessKindData() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/process/kinds`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          },
        )
        this.processKinds = res.data
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 工場を取得
    async getFactoryData() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/spaces`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: {
              key: 'site',
            },
          },
        )
        this.factories = res.data
      } catch (error) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 部署を取得
    async getDepartmentData() {
      try {
        const res = await this.$axios.get(
          `${this.$appConfig.CommonApiUrl}/spaces`,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
            params: {
              key: 'dep',
            },
          },
        )
        this.departments = res.data
      } catch (error) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    // 値を初期化
    async init() {
      this.load = true
      await this.getMasterData()
      await this.getProcessKindData()
      await this.getFactoryData()
      await this.getDepartmentData()
      await this.getProcessData()
      this.load = false
    },
    async updateProcessSortUp(i) {
      // 操作ブロックのためローディングを表示する
      this.load = true
      // 指定の工程を1段上に移動する
      let process = this.changeProcesses
      let targetProcessSortIndex = 0

      targetProcessSortIndex = process[i].sort
      process[i].sort = process[i - 1].sort
      process[i - 1].sort = targetProcessSortIndex

      await this.updateProcessSort(process)
      // ローディング表示を終了させる
      this.load = false
    },
    async updateProcessSortDown(i) {
      // 操作ブロックのためローディングを表示する
      this.load = true
      // 指定の工程を1段下に移動する
      let process = this.changeProcesses
      let targetProcessSortIndex = 0

      targetProcessSortIndex = process[i].sort
      process[i].sort = process[i + 1].sort
      process[i + 1].sort = targetProcessSortIndex

      await this.updateProcessSort(process)
      // ローディング表示を終了させる
      this.load = false
    },
    async updateProcessSort(targets) {
      // 工程の並び順を更新して工程一覧を取り直す
      try {
        await this.$axios.put(
          `${this.$appConfig.CommonApiUrl}/processes`,
          {
            targets: targets,
          },
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          },
        )
        await this.getProcessData()
      } catch (err) {
        await this.getProcessData()
        this.$toasted.show(this.$t('データ削除エラーメッセージ'))
      }
    },
    // ウィンドウの高さからスクロールがある部分の項目の高さを調整と背景の高さを調整
    adjustmentHeight(array = []) {
      const boardBodyRightInner = document.getElementById(
        'board-body-right__inner',
      )
      const boardBody = document.getElementById('board-body')
      const titleHeight = $('#board-title').outerHeight(true)
      const selectHeight = $('#board-select').outerHeight(true)
      const boardHeadHeight = $('#board-head').outerHeight(true)
      const footerHeight = $('#board-footer').outerHeight(true)
      const marginBottom = 0
      const totalHeght =
        titleHeight +
        selectHeight +
        boardHeadHeight +
        footerHeight +
        marginBottom
      const windowHeight = window.innerHeight
      let count = 0
      if (array.length === 0) {
        boardBody.style.height = '38px'
        boardBodyRightInner.style.height = '38px'
        return
      }
      count += array.length
      array.map(item => {
        if (item.userIds.length === 0) return count++
        if (item.userIds.length) return (count += item.userIds.length)
      })
      const rightHeight = count * 38
      boardBodyRightInner.style.height = `${rightHeight}px`
      if (windowHeight - totalHeght > rightHeight) {
        boardBody.style.height = rightHeight + 'px'
      } else if (windowHeight - totalHeght < 400) {
        boardBody.style.height = '40rem'
        boardBody.style.margin = '0 0 8rem 0'
      } else {
        boardBody.style.height = windowHeight - totalHeght + 'px'
      }
    },
    // 会社情報登録のモーダルを開く処理
    companyModalOpen() {
      this.$refs.company.modalOpen()
    },
    // 工場登録のモーダルを開く処理
    factoryModalOpen() {
      this.$refs.factory.createModalOpen()
    },
    // 部署登録のモーダルを開く処理
    departmentModalOpen() {
      this.$refs.department.createModalOpen()
    },
    // 工程登録のモーダルを開く処理
    facilityModalOpen(item = {}) {
      this.$refs.facility.createModalOpen(item, this.processKinds, this.master)
    },
    // 工程登録のモーダルを開く処理
    assignedModalOpen(item = {}) {
      this.$refs.assigned.modalOpen(item, this.processKinds, this.master)
    },
    // 担当登録のモーダルを開く処理
    userModalOpen(item = {}, processId) {
      this.$refs.user.createModalOpen(item, processId)
    },
    getProcessKindMessageKey(process) {
      let processKindMessageKey = ''
      this.processKinds.some(item => {
        // 一致データがあれば処理終了
        return item.datas.some(data => {
          if (data.id === process.processKindId) {
            // 工程のprocessKindIdと一致する工程区分名（messageKey）を取得
            processKindMessageKey = data.messageKey
            // 一致データがあれば処理終了
            return true
          }
        })
      })
      return processKindMessageKey
    },
  },
  computed: {
    changeProcesses() {
      if (this.processes.length === 0) {
        return []
      }
      if (!this.siteId && !this.depId) {
        return this.processes
      }
      if (this.siteId && !this.depId) {
        return this.processes.filter(item => item.site === this.siteId)
      }
      if (!this.siteId && this.depId) {
        return this.processes.filter(item => item.dep === this.depId)
      }
      if (this.siteId && this.depId) {
        return this.processes.filter(
          item => item.site === this.siteId && item.dep === this.depId,
        )
      }
      return []
    },
    changeDepartment() {
      if (!this.siteId) return this.departments
      return this.departments.filter(item => item.parentId === this.siteId)
    },
    ...mapGetters({
      authorization: 'auth/authorization',
      monthlySchedule: 'date/monthlySchedule',
      userdata: 'auth/userdata',
    }),
  },
  watch: {
    changeProcesses: {
      handler: function(newVal) {
        this.adjustmentHeight(newVal)
      },
      deep: true,
    },
    depId: function(newVal) {
      if (!this.siteId && newVal) {
        const dep = this.departments.filter(item => item.id === newVal)
        this.siteId = dep[0].parentId
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.board {
  position: relative;
}
.board-thead {
  height: 7.4rem;
}
.btn-board {
  font-size: 1rem !important;
  height: auto !important;
  padding: 0.2rem 0.5rem;
}
.board-calendar-holiday {
  background-color: rgba(255, 219, 219, 0.4);
}
.board-body-even {
  background-color: #fffdf4;
}
.board-body-odd {
  background-color: #f2f5ff;
}
.board-body-right {
  display: flex;
  position: relative;
  z-index: 0;
}
.board-body-left {
  position: relative;
  z-index: 1;
}
#board-body-left-table {
  table-layout: fixed;
}
.board-body-right__inner {
  width: 100%;
  align-items: stretch;
  background: repeating-linear-gradient(
    -45deg,
    #f5f5f5,
    #f5f5f5 7px,
    #ddd 0,
    #ddd 14px
  );
  border-top: none !important;
  border-right: none !important;
  box-sizing: border-box;
}
.input-loading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  align-items: center;
  .spinner-border {
    width: 5rem;
    height: 5rem;
  }
}
</style>
